import React from 'react';
import SvgIcon from '../SvgIcon';
var CheckboxUncheckedIcon = function CheckboxUncheckedIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    stroke: "#A3A7B1"
  }));
};
export default CheckboxUncheckedIcon;